// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__3BgJt","loaderOuter":"PageOverlayLoader_loaderOuter__3hYRG"};